import React from "react";
import { FormHeading } from "../utils/CommonComonents/FormHeading";
import { usePromotionsStyles } from "../styles/PromotionsFormStyles";
import { Paper } from "@mui/material";
import GeoVisualization from "../components/analysis/GeoVisualization";

function GeoAnalysis(_props) {
    const classes = usePromotionsStyles();

    return (
        <>
            <FormHeading title={"Travel zone analysis"} classes={classes} />
            <Paper
                rounded="true"
                elevation={0}
                sx={{ marginBottom: "18px", padding: "8px" }}
            >
                <GeoVisualization />
            </Paper>
        </>
    );
}

export default GeoAnalysis;
